import { ERoutes } from "../constants/routes";

export const UNSIGNED_USER_ROUTES = [
  ERoutes.Auth,
  ERoutes.Login,
  ERoutes.OAuthLogin,
  ERoutes.OAuthRegister,
  ERoutes.Register,
  ERoutes.ForgotPassword,
  ERoutes.AuthBrands,
];
